import React from "react";
import classNames from "classnames";
import NewCustomCssTransition from "@/app/components/new_custom_css_transition/widget";
import styles from "./styles.module.scss";

interface ModalWidgetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

const ModalWidget: React.FC<ModalWidgetProps> = ({ isOpen, onClose, children, className }) => {
  return (
    <NewCustomCssTransition bool={isOpen}>
      <div
        className={classNames(styles.modal, className, { [styles.show]: isOpen })}
        onClick={onClose}
      >
        {children}
      </div>
    </NewCustomCssTransition>
  );
};

export default ModalWidget;
